import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface ExitConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

export default function ExitConfirmDialog({
  open,
  onOpenChange,
  onConfirm,
}: ExitConfirmDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="bg-dark-card border-cyan/20">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-foreground text-xl">
            Exit Audit?
          </AlertDialogTitle>
          <AlertDialogDescription className="text-light-gray/90">
            Your progress will be lost if you leave now. Are you sure you want to exit the audit?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="bg-transparent border-medium-gray/30 text-foreground hover:bg-medium-gray/10">
            Continue Audit
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="bg-destructive hover:bg-destructive/90 text-white"
          >
            Exit Anyway
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
